import { DatePicker, Form } from 'antd';

import { getDisabledDatesAfterToday } from 'utils';

import { TFieldProps } from 'types';

const { Item } = Form;
const { RangePicker } = DatePicker;

export const FormDateRangePicker = ({
  name,
  label,
  rules,
  tooltip,
  disabled,
  allowEmpty,
  itemClassName,
  onDateRangeChange,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
  >
    <RangePicker
      inputReadOnly
      className='w-full'
      disabled={disabled}
      onChange={onDateRangeChange}
      disabledDate={getDisabledDatesAfterToday}
      allowEmpty={allowEmpty}
    />
  </Item>
);
